import serviceWorkerUrl from "../sw.ts?worker&url";

export function registerPortalServiceWorker() {
	if (!("serviceWorker" in navigator)) return;
	const register = () =>
		navigator.serviceWorker
			.register(serviceWorkerUrl, { type: "module", ...(import.meta.env.PROD ? { scope: "/" } : {}) })
			.catch(() => undefined);
	if (document.readyState === "complete") void register();
	else window.addEventListener("load", () => void register(), { once: true });
}
export function portalPushDeepLink(data: unknown) {
	if (!data || typeof data !== "object" || Array.isArray(data)) return "/projects";
	const value = data as { type?: unknown; inboxItemId?: unknown };
	return value.type === "inbox" && typeof value.inboxItemId === "string"
		? `/inbox/${encodeURIComponent(value.inboxItemId)}`
		: "/projects";
}
